import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { faqWidgetStyles } from "@solveindustrial/Widgets/VerndaleBox/FaqWidget";
import { css } from "styled-components";

faqWidgetStyles.title = {
    variant: "h2",
};

faqWidgetStyles.accordion = {
    css: css`
        dt {
            margin-top: 20px;

            ${mediaQueriesBP.maxMD} {
                margin-top: 24px;
            }

            button {
                border-top: 1px solid ${getColor(colorStrings.commonGlobalBlack)} !important;

                &:focus {
                    border-top: 2px solid ${getProp("theme.focus.color", "#09f")} !important;
                }
            }

            &:first-child {
                margin-top: 0;
            }
        }
    `,
};
